import { render, staticRenderFns } from "./listaProtocolo.vue?vue&type=template&id=4eca2624&scoped=true&"
import script from "./listaProtocolo.vue?vue&type=script&lang=js&"
export * from "./listaProtocolo.vue?vue&type=script&lang=js&"
import style0 from "./listaProtocolo.vue?vue&type=style&index=0&id=4eca2624&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eca2624",
  null
  
)

export default component.exports